import { ErrorBoundary } from "@aurem/components";
import { useI18n } from "providers/I18nProvider";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const AppErrorBoundary = ({ children }: Props) => {
  const { t } = useI18n();

  return (
    <ErrorBoundary
      // eslint-disable-next-line no-console
      logError={console.error}
      heading={t("apps.admin.pages.errorBoundary.title")}
      description={t("apps.admin.pages.errorBoundary.subtext")}
      resetLabel={t("apps.admin.pages.errorBoundary.reload")}
    >
      {children}
    </ErrorBoundary>
  );
};
